import { ILocalizeRequest } from '@addins/core/map';
import { CallcardButtonTool } from './callcard-button-tool';

export class LocalizeButtonTool extends CallcardButtonTool<ILocalizeRequest> {
  constructor(text: string, icon: string, position: number) {
    super(text, icon, position);
  }
}
